import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'
import {useNavigate} from 'react-router'

import {TasksApiPath} from '../../consts'
import {ShiftTaskDto} from '../../types'
import {handleTasksError as handleError} from '../../utils'

const QueryKey = 'shift-task'

type UseShiftTaskOptions = UseQueryOptions<ShiftTaskDto | undefined, AxiosError>

type Params = {
  plantId: string
  externalId: string
}

export const useShiftTask = ({plantId, externalId}: Params, options?: UseShiftTaskOptions) => {
  const navigate = useNavigate()
  const path = `${TasksApiPath.SHIFT_HANDOVER}/${plantId}/events/${externalId}`

  const query = useQuery<ShiftTaskDto | undefined, AxiosError>({
    queryKey: [QueryKey, externalId, plantId],
    queryFn: async ({signal}) => {
      const {data} = await ApiClient.axiosInstance.get<ShiftTaskDto>(path, {signal})

      return data
    },
    ...options
  })
  useEffect(() => {
    if (query.error) {
      handleError(query.error, navigate)
    }
  }, [query.error, navigate])
  return query
}
